var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgexport10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.682,
    height: 43.692,
    viewBox: "0 0 43.682 43.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.055)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.055)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.18,7.163A7.178,7.178,0,1,1,180,0,7.178,7.178,0,0,1,187.18,7.163Z",
    transform: "translate(-162.724)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.809,208.3l-4.747,4.734,0,0-4.744-4.732,1.809-1.81,1.655,1.651V201.6h2.56v6.543L209,206.486Z",
    transform: "translate(-188.784 -184.4)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.793,185.871l-3.281,5.669-.606-2.256-2.472.663,1.737,6.467,6.488-1.734L62,192.209l-2.267.606,3.278-5.664Z",
    transform: "translate(-54.434 -170.013)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.321,194.68l6.488,1.734,1.737-6.467-2.472-.663-.606,2.256-3.281-5.669-2.215,1.28,3.278,5.664-2.267-.606Z",
    transform: "translate(-332.989 -170.013)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.925 31.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.485,364.929h12.557v12.548H182.485Z",
    transform: "translate(-182.485 -364.929)",
    fill: "#09eaa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.955,364.929h6.2v12.548h-6.2Z",
    transform: "translate(-250.601 -364.929)",
    fill: "#09eaa3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.893,206.486l1.809,1.81-4.747,4.734V201.6h1.276v6.543Z",
    transform: "translate(-239.677 -184.4)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.133,7.163a7.178,7.178,0,0,1-7.178,7.162V0A7.178,7.178,0,0,1,264.133,7.163Z",
    transform: "translate(-239.676)",
    fill: "#1e90ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,377.486H.055v-6.278a6.323,6.323,0,0,1,6.315-6.278h6.242v6.278A6.322,6.322,0,0,1,6.3,377.486Z",
    transform: "translate(-0.055 -364.929)",
    fill: "#09eaa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,377.486H.055l12.557-12.557v6.278A6.322,6.322,0,0,1,6.3,377.486Z",
    transform: "translate(-0.055 -364.929)",
    fill: "#09eaa3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.125 31.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.432,371.136v6.241h-6.278a6.323,6.323,0,0,1-6.279-6.315V364.82h6.279A6.322,6.322,0,0,1,377.432,371.136Z",
    transform: "translate(-364.875 -364.82)",
    fill: "#09eaa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.432,371.136v6.241L364.875,364.82h6.279A6.322,6.322,0,0,1,377.432,371.136Z",
    transform: "translate(-364.875 -364.82)",
    fill: "#09eaa3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport10);
export default __webpack_public_path__ + "static/media/svgexport-10.2081a8b02114eaeb4acbd4bdbd3ead39.svg";
export { ForwardRef as ReactComponent };